import { Authenticationservice } from './../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { Data, Router } from '@angular/router';

@Component({
  selector: 'app-acceptbarcode',
  templateUrl: './acceptbarcode.component.html',
  styleUrls: ['./acceptbarcode.component.css']
})
export class AcceptbarcodeComponent implements OnInit {

  userdata: any;

  constructor(
    private spinner: NgxSpinnerService,
    private auth: Authenticationservice,

  ) {
    this.userdata = this.auth.Authention();
    console.log('userdata:', this.userdata)

  }

  inDate = [];
  ngOnInit(): void {
    let d1 = new Date(), d2 = new Date();
    d1.setDate(d1.getDate() - 7);
    this.inDate[0] = d1;
    this.inDate[1] = d2;
    setTimeout(() => {
      this.Loadbarcodelist();
    }, 100);
  }

  date2en(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  txtSearch = '';
  codelist: any[] = [];
  txthleft = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net';
  // โหลดข้อมูลการขอ Barcode เพิ่ม
  Loadbarcodelist() {
    let dateI = this.inDate;
    this.spinner.show();
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_request_qcard_w?[year_id]='6667'&[supzone]='" + this.userdata.zonedata + "'";
    let url = `${this.txthleft}/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_request_qcard]&w=cast([created_at]as date)between'${this.date2en(dateI[0])}'and'${this.date2en(dateI[1])}'and[Partcode]='${this.userdata.zonedata}'order by[created_at] desc`
    axios.get(url)
      .then(res => {
        this.codelist = res.data;
        this.spinner.hide();
      }).catch(err => { throw (err) })
  }

  // อนุมัติบาร์โค้ด แปลง
  AcceptBarcode(data: any) {
    let num_qcard: number = data.qcard_adj + data.num_qcard;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/addToQcard1234?Qtype=" + qtype + "&landno=" + landno + "&qcard=" + num_qcard;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=" + data.itid + "&qcard_adj=" + num_qcard;
    let url = `${this.txthleft}/dbcps/update_t_s_w?t=[dbintechgen3].[dbo].[areas]&s=[qcard_adj]=${num_qcard}&w=[id]='${data.area_id}'`
    if (confirm(`ต้องการอนุมัติ ขอเพิ่ม ${data.num_qcard} เที่ยว รายการนี้ใช่หรือไม่`)) {
      axios.get(url)
        .then(res => {
          if (res.data.rowsAffected[0] >= 1) {
            this.AcceptBarcode2(data.id);
            alert("บันทึกรายการเรียบร้อย");
          }
          else {
            alert("!! ไม่สำเร็จกรุณาลองใหม่ !!!");
          }
        }).catch(err => { throw (err) })
    }
    else {
    }
  }

  // อนุมัติบาร์โค้ด2 แปลง
  AcceptBarcode2(id: string) {
    let url2 = `${this.txthleft}/app_farmer/approve_request_qcard?sup_approve=` + this.userdata.supcode + "&id=" + id;
    axios.get(url2)
      .then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("บันทึกรายการเรียบร้อย");
          this.Loadbarcodelist();
        }
        else {
          alert("!! ไม่สำเร็จกรุณาลองใหม่ !!!");
        }
      }).catch(err => { throw (err) })
  }

  disAcceptBarcode(id: string) {
    let url2 = `${this.txthleft}/app_farmer/dis_approve_request_qcard?&id=` + id;
    if (confirm('ยืนยันไม่อนุมัติรายการนี้ใช่หรือไม่')) {
      axios.get(url2)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("บันทึกรายการเรียบร้อย");
            this.Loadbarcodelist();
          }
          else {
            alert("!! ไม่สำเร็จกรุณาลองใหม่ !!!");
          }
        }).catch(err => { throw (err) })
    }
  }

  // แปลงวันที่  

  THtoLocalstring(thisdate: any) {
    if (!thisdate) { return ''; }
    const date1 = new Date(thisdate);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }
}


